import {
    WALLET_CONNECT,NETWORK

} from '../constant';

export const setWallet = details => {
    return {
        type: WALLET_CONNECT,
        payload: details
    };
};


export const selectNetwork = details => {
    return {
        type: NETWORK,
        payload: details
    };
};